import { ONEWAY_JOURNEY_TYPE, DOMESTIC, FLIGHT_CLASS_OBJECT } from './text';

export const TODAY = new Date();

export const TODAYPLUSNOOFDAYS = 3;

export const TODAYPLUSDATE = new Date(TODAY.setDate(TODAY.getDate() + TODAYPLUSNOOFDAYS));

export const NULL = null;

export const DEPARTUREDATEFORSEOWITHINNOOFDAYS = 90;

export const SOURCE = {
  iata: 'DEL',
  n: 'Indira Gandhi International Airport',
  ct: 'New Delhi',
  cc: 'IN',
  cnty: 'India',
  con: 'Asia',
  coc: 'AS',
  d: 0,
  lcs: {
    cc: 'CTDEL'
  },
  t: 'airport'
};

export const DESTINATION = {
  iata: 'BLR',
  n: 'Bengaluru International Airport',
  ct: 'Bengaluru',
  cc: 'IN',
  cnty: 'India',
  con: 'Asia',
  coc: 'AS',
  d: 0,
  lcs: {
    cc: 'CTBLR'
  },
  t: 'airport'
};

export const DEPARTURE = TODAYPLUSDATE;

export const ARRIVAL = NULL;

export const PASSENGERS = { adult: 1, child: 0, infant: 0 };

export const FLIGHT_CLASS = FLIGHT_CLASS_OBJECT[0];

export const JOURNEY_TYPE = ONEWAY_JOURNEY_TYPE;

export const TRAVEL_TYPE = DOMESTIC;

export const DEFAULT_SEARCH_WIDGET_DATA = {
  source: SOURCE,
  destination: DESTINATION,
  departure: DEPARTURE,
  arrival: ARRIVAL,
  passengers: PASSENGERS,
  flightClass: FLIGHT_CLASS,
  journeyType: JOURNEY_TYPE,
  selectedFareIdentifier: '',
  isDefaultSrcAndDest: true,
  travelType: TRAVEL_TYPE
};

export const OFFERS_DATA = [];

export const RECENT_SEARCH_DATA = [];

export const SEO_DATA = {
  h1: 'Book Domestic and International Flight Tickets',
  title: 'Flight Tickets, Flights Booking at Lowest Airfare, Book Air Tickets-Goibibo'
};

export const POPULAR_CITIES_VALUES = [
  {
    // Delhi
    iata: 'DEL',
    n: 'Indira Gandhi International Airport',
    ct: 'New Delhi',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTDEL'
    },
    t: 'airport'
  },
  {
    // Mumbai
    iata: 'BOM',
    n: 'Chhatrapati Shivaji International Airport',
    ct: 'Mumbai',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTBOM'
    },
    t: 'airport'
  },
  {
    // Bangalore
    iata: 'BLR',
    n: 'Bengaluru International Airport',
    ct: 'Bengaluru',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTBLR'
    },
    t: 'airport'
  },
  {
    // Pune
    iata: 'PNQ',
    n: 'Pune Airport',
    ct: 'Pune',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTPNQ'
    },
    t: 'airport'
  },
  {
    // Kolkata
    iata: 'CCU',
    n: 'Netaji Subhash Chandra Bose International Airport',
    ct: 'Kolkata',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTCCU'
    },
    t: 'airport'
  },
  {
    // Goa
    iata: 'GOI',
    n: 'Dabolim Goa International Airport',
    ct: 'Goa',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTGOI'
    },
    t: 'airport'
  },
  {
    // Hyderabad
    iata: 'HYD',
    n: 'Rajiv Gandhi International Airport',
    ct: 'Hyderabad',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTHYDERA'
    },
    t: 'airport'
  },
  {
    // Chennai
    iata: 'MAA',
    n: 'Chennai International Airport',
    ct: 'Chennai',
    cc: 'IN',
    cnty: 'India',
    con: 'Asia',
    coc: 'AS',
    d: 0,
    lcs: {
      cc: 'CTMAA'
    },
    t: 'airport'
  }
];

export const SEO_SEARCH_STRING = `gi_source=google&gi_medium=organic&campaign=organic&gocashoffer=true`;

export const BANNER_POSITIONS = [4, 8, 12, 16, 20];

export const DWEB_BANNER_POSITIONS = [3, 7, 11, 15, 19];

export const godata = {
  show_popup: true,
  title: 'Welcome to Goibibo App',
  expiry_date: '',
  toast_msg: 'Code copied: GOAPP. Use it during checkout',
  subtitle: 'Get App exclusive deals and offers!!',
  cta_text: 'Copy code : GOAPP',
  coupon_code: 'GOAPP',
  image_url: 'https://gos3.ibcdn.com/offer-1648801326.png'
};

export const fareOptionsMapping = {
  'ft=sc': 'SC',
  'ft=a': 'AF',
  'student=true': 'ST',
  'ft=d': 'D'
};

export const THANKYOU_PAGE_API_HIT_COUNT = 3;

export const THANK_YOU_PAGE_API_HIT_TIME_INTERVAL = 10000;

export const THANKYOU_PAGE_CONFIRMED_STATUS_LIST = [
  'Confirmed',
  'Booking Confirmed',
  'Trip Confirmed',
  'Booking Successful',
  'Reservation Done',
  'Booking Reserved'
];
